import { createContext, useContext, useState } from "react";
import { themeOptions } from "./../Utils/themeOptions";

const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
  let defaultValue = themeOptions[0].value;
  try {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      defaultValue = JSON.parse(storedTheme);
    }
  } catch (err) {
    console.warn(
      "Could not parse saved theme in localStorage, falling back to default.",
    );
    localStorage.removeItem("theme"); // Clear the invalid string
  }

  const [theme, setTheme] = useState(defaultValue);

  const values = {
    theme,
    setTheme,
  };

  return (
    <ThemeContext.Provider value={values}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
